import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.apps;

export const appsListSelector = createSelector(getState, (state) => state.apps);
export const appsMetaDataSelector = createSelector(getState, (state) => state.metaData);

export const isLoadingCreateAppSelector = createSelector(
  getState,
  (state) => state.isLoadingCreateApp
);
export const isLoadingFetchAppsSelector = createSelector(
  getState,
  (state) => state.isLoadingFetchApps
);
export const isLoadingUpdateAppSelector = createSelector(
  getState,
  (state) => state.isLoadingUpdateApp
);
export const isLoadingDeleteAppSelector = createSelector(
  getState,
  (state) => state.isLoadingDeleteApp
);
